module.exports = __webpack_public_path__ + "static/img/home_logo1.938c2f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_logo1.png
// module id = 22EB
// module chunks = 3